import React from 'react';
import {Link} from "react-router-dom";
import "../Blog.scss";

const Sidebar = () => {

  return (
    <div className="col-2 col-lg-3 offset-xl-1 sidebar-wrapper">
      <div className="sidebar transition-3">
        <h5 className="text-uppercase">Categories:</h5>
        <ul>
          <li><Link to="/blog/categories/installation/1">Installation</Link></li>
          <li><Link to="/blog/categories/paving-stones/1">Paving Stones</Link></li>
          <li><Link to="/blog/categories/contractors/1">Contractors</Link></li>
          <li><Link to="/blog/categories/driveways/1">Driveways</Link></li>
          <li><Link to="/blog/categories/patios/1">Patios</Link></li>
          <li><Link to="/blog/categories/walkways/1">Walkways</Link></li>
          <li><Link to="/blog/categories/choosing-a-paving-material/1">Paving Materials</Link></li>
          <li><Link to="/blog/categories/retaining-walls/1">Retaining Walls</Link></li>
          <li><Link to="/blog/categories/permeable-pavers/1">Permeable Pavers</Link></li>
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
